<template>
  <div class="adduser">
    <div class="newsDetial-header">
      <div class="newsDetial-title">添加用户</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照系统要求填写用户信息，创建和修改用户信息
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">用户信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 用户信息 -->
        <a-descriptions layout="vertical">
          <a-descriptions-item label="用户姓名">
            <a-input
              class="w300"
              placeholder="请添加用户姓名"
              v-model="Form.fullName"
              @change="eightyfive('fullName')"
            />
          </a-descriptions-item>
          <a-descriptions-item label="所在机构1">
            <a-cascader
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :options="treeData"
              change-on-select
              placeholder="请选择所在机构1"
              v-model="organizationId"
              :field-names="{
                label: 'organizationName',
                value: 'id',
                children: 'treeList'
              }"
            />
          </a-descriptions-item>

          <a-descriptions-item label="行政职务">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.dutiesVal"
            >
              <a-select-option
                v-for="item in dutiesValList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="电话">
            <a-input
              class="w300"
              v-model="Form.phoneNumber"
              placeholder="请添加电话"
              @blur="phoneNumberBlur"
            />
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            <a-input
              class="w300"
              v-model="Form.description"
              placeholder="请添加备注"
              @change="eightyfive('description')"
            />
          </a-descriptions-item>
          <a-descriptions-item label="所在机构2">
            <a-tree-select
              allowClear
              v-model="Form.organizationlist"
              class="w300"
              multiple
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择所在机构2"
              tree-default-expand-all
              :replaceFields="{
                key: 'id',
                value: 'id',
                children: 'treeList',
                title: 'organizationName'
              }"
            >
            </a-tree-select>
          </a-descriptions-item>
        </a-descriptions>
        <!-- 用户配置 -->
        <div class="configuration">
          <div class="configuration-top">用户配置</div>
          <blank height="35"> </blank>
          <div class="pl20">
            <div class="configuration-title">用户状态：</div>
            <blank height="15"> </blank>
            <a-radio-group name="radioGroup" v-model="Form.userStatue">
              <a-radio :value="1"> 在职 </a-radio>
              <a-radio :value="2"> 退休 </a-radio>
            </a-radio-group>
            <blank height="35"> </blank>
            <div class="configuration-title">资料权限：</div>
            <blank height="15"> </blank>
            <a-radio-group name="radioGroup" v-model="Form.secretLevel">
              <a-radio :value="10"> 普通 </a-radio>
              <a-radio :value="100"> 重要 </a-radio>
            </a-radio-group>
            <blank height="35"> </blank>
            <div class="configuration-title">权限配置</div>
            <blank height="15"> </blank>
            <div class="configuration-cont">
              <a-checkbox-group v-model="Form.roleIds">
                <a-checkbox
                  :value="i.roleId"
                  name="type"
                  v-for="(i, index) in RoleList"
                  :key="index"
                >
                  {{ i.roleZhName }}
                </a-checkbox>
              </a-checkbox-group>
            </div>
            <blank height="35"> </blank>
            <div class="configuration-title">工作台配置</div>
            <blank height="10"> </blank>
            <a-checkbox v-model="checkAll" @change="onCheckAllChange">
              全选
            </a-checkbox>
            <blank height="10"> </blank>
            <div class="configuration-cont">
              <a-checkbox-group
                v-model="FormHomePageIds"
                @change="excelHeaderonChange"
              >
                <a-checkbox
                  :value="i.homePageId"
                  name="type"
                  v-for="(i, index) in HomePageList"
                  :key="index"
                >
                  {{ i.HomePageName }}
                </a-checkbox>
              </a-checkbox-group>
            </div>
            <blank height="35"> </blank>
            <div class="configuration-title">启用/禁用：</div>
            <blank height="15"> </blank>
            <a-radio-group name="radioGroup" v-model="Form.enableNum">
              <a-radio :value="1"> 启用 </a-radio>
              <a-radio :value="2"> 禁用 </a-radio>
            </a-radio-group>
          </div>
          <blank height="15"> </blank>
        </div>
      </div>
    </div>

    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goBack">
        返回
      </a-button>
      <a-button
        type="primary"
        :style="{ marginRight: '42px' }"
        @click="add"
        :loading="loading"
      >
        提交
      </a-button>
    </bottomSuspension>
  </div>
</template>

<script>
import {
  getUserDetails,
  getTreeList,
  addUser,
  updateUser,
  getRoleList
} from './api/api'
import { mapState, mapActions } from 'vuex'
import { validatorPhone } from '@/assets/js/auth'
export default {
  data() {
    return {
      loading: false,
      treeData: [], // 组织机构树
      RoleList: [], //权限列表
      homePageIds: ['1', '2', '3', '4', '5', '6', '7'], // 全选效果
      checkAll: false,
      HomePageList: [
        { homePageId: '1', HomePageName: '代办任务' },
        { homePageId: '2', HomePageName: '已办任务' },
        { homePageId: '3', HomePageName: '我的申请' },
        { homePageId: '4', HomePageName: '公文' },
        { homePageId: '5', HomePageName: '简报' },
        { homePageId: '6', HomePageName: '新闻' },
        { homePageId: '7', HomePageName: '我的整改任务' }
      ], // 首页配置列表
      FormHomePageIds: [], // 当前用户所选的首页配置列表
      organizationId: [],
      Form: {
        userStatue: 1, // 用户状态
        secretLevel: 10, // 资料权限
        enableNum: 1, // 启用禁用
        roleIds: []
      },
      id: ''
    }
  },
  computed: {
    ...mapState({
      dutiesValList: (state) => state.bytype.dutiesValList // 职务字典表
    })
  },
  created() {
    // 组织机构树
    getTreeList().then((res) => {
      this.treeData = res.data.data
    })
    // 权限列表
    getRoleList({ page: 1, size: 100, enableNum: 1 }).then((res) => {
      this.RoleList = res.data.data
    })
    //职务
    this.getdutiesVal()
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      getUserDetails({ id: this.id }).then((res) => {
        this.Form = res.data.data
        let organizationArr = []
        organizationArr = this.Form.organizationids.map(Number)
        /**
         * @description 解决方案：后端处理：根据当前登录人获取组织机构数减少层级。getTreeList中的treeData层级根据当前登录人公司是否为子公司进行截取  后端getUserDetails详情接口通过层级判断进行organizationids截取实现子公司还有子公司的嵌套,如果当前登录人是顶层则不需要截取。当前登录人是子公司的人 则需要通过公司层级进行截取。
         * @author qi
         * @date 2023-04-07
         */
        // 原来代码想要通过isParent字段进行剪切 去掉父层 发现无法回显
        // 原来代码：
        // isParent = 1 总公司 isParent = 2 子公司
        // if (this.Form.isParent == 1) {
        //   this.organizationId = organizationArr
        // } else {
        // this.organizationId = organizationArr.splice(1, 2)
        // }
        this.organizationId = organizationArr
        if (this.Form.homePageIds && this.Form.homePageIds.length > 0) {
          this.FormHomePageIds = this.Form.homePageIds.split(',')
          this.excelHeaderonChange()
        }
      })
    }
  },
  methods: {
    ...mapActions(['getdutiesVal']),
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.FormHomePageIds = this.homePageIds
      } else {
        this.FormHomePageIds = []
      }
    },
    excelHeaderonChange() {
      //判断是否全选
      if (this.homePageIds.length == this.FormHomePageIds.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85)
        this.$message.destroy()
        this.$message.warning('只能输入85个字')
      }
    },
    add() {
      if (this.organizationId.length > 0) {
        // 新增和修改参数 只需要最后一个 id
        this.Form.organizationId =
          this.organizationId[this.organizationId.length - 1]
      }
      if (!validatorPhone(this.Form.phoneNumber)) {
        this.$message.error('请输入正确的手机号！')
      } else {
        this.loading = true
        if (this.FormHomePageIds.length > 0) {
          this.Form.homePageIds = this.FormHomePageIds.join(',')
        }
        if (this.id) {
          updateUser(this.Form).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('修改用户信息成功')
              this.goBack()
              this.loading = false
            } else {
              this.loading = false
            }
          })
        } else {
          addUser(this.Form).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('添加用户成功')
              this.goBack()
              this.loading = false
            } else {
              this.loading = false
            }
          })
        }
      }
    },
    phoneNumberBlur() {
      if (!this.Form.phoneNumber) return
      let isPhone = validatorPhone(this.Form.phoneNumber)
      if (!isPhone) {
        this.$message.error('请输入正确的手机号！')
      }
    },
    goBack() {
      this.$router.push('/userList')
    }
  }
}
</script>

<style lang="scss" scoped>
.adduser {
  .newsDetial-header {
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .configuration {
        padding: 20px;
        color: rgba(80, 80, 80, 1);
        background-color: rgba(229, 229, 229, 0.3357142857142857);
        .pl20 {
          padding-left: 20px;
        }
        .configuration-top {
          color: rgba(0, 0, 0, 0.85);
          font-size: 16px;
        }
        .configuration-title {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
        .configuration-cont {
          .ant-checkbox-wrapper + .ant-checkbox-wrapper {
            margin-left: 0;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/adduser.vue